import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactComponent as GooglePlay } from '../images/google-play.svg';
import { ReactComponent as AppleStore } from '../images/apple-store.svg';
import Link from '@mui/material/Link';
class Download extends React.Component {
  render() {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Box sx={{ justifyContent: 'center', space: 1 }}>
          <Link
            color="inherit"
            href="https://apps.apple.com/us/app/heartopinion/id1529536456"
            target="_blank"
            rel="noopener noreferrer">
            <AppleStore />
          </Link>
          <Link
            color="inherit"
            href="https://play.google.com/store/apps/details?id=org.childrenshospital.hcsop"
            target="_blank"
            rel="noopener noreferrer">
            <GooglePlay />
          </Link>
        </Box>
        <Typography variant="body2" sx={{ mt: 2 }}>
          Check out the app!
        </Typography>
      </Box>
    );
  }
}

export default Download;
